module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Lewis Rice",
      "src": require("../assets/images/lewis-rice-logo-white.svg")
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Estate Planning Document Portal")]), _vm._v(" "), (_vm.loginHelpStep == '') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:username",
      value: (_vm.username),
      expression: "username",
      arg: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:password",
      value: (_vm.password),
      expression: "password",
      arg: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.requestLogin
    }
  }, [_vm._v("login")])]), _vm._v(" "), _c('div', [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.setLoginHelpStep('reset-password')
      }
    }
  }, [_vm._v("Need help logging in?")])])])]) : _vm._e(), _vm._v(" "), (_vm.loginHelpStep == 'reset-password') ? _c('div', {
    staticClass: "get-login-help"
  }, [_c('h4', [_vm._v("Enter your account email below to receive instructions for resetting your login credentials.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:username",
      value: (_vm.username),
      expression: "username",
      arg: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-default",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.requestPasswordReset
    }
  }, [_vm._v("reset password")])]), _vm._v(" "), _c('div', [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.setLoginHelpStep('')
      }
    }
  }, [_vm._v("Back to login")])])])]) : _vm._e(), _vm._v(" "), (_vm.loginHelpStep == 'email-sent') ? _c('div', {
    staticClass: "get-login-help"
  }, [_c('h2', [_vm._v("Please check your email.")]), _vm._v(" "), _c('h4', [_vm._v("You should receive a message containing a link to reset your password.")]), _vm._v(" "), _c('div', [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.setLoginHelpStep('')
      }
    }
  }, [_vm._v("Back to login")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23e7fb40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 276
// module chunks = 1